import { Box, Grid, Button, Select } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetCustomerGroupReferenceData,
  SearchCustomerTrustLevel,
  UpdateCustomerTrustLevel,
  setState,
} from "./functionalAdminSlice";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import _ from "lodash";
import Alert from "../../components/ui/Alert";


export default function CustomerTrustLevel() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [partnerType, setPartnerType] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [alert, setAlert] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [updatedValues, setUpdatedValues] = React.useState([]);
  //Only get Initial Values Data
  const functionAdmin = useSelector((state) => state.functionAdmin);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,

    getCustomerGroupRefData,
    customerTrustLevelData,
    clearCustomerTrustLevel,
  } = functionAdmin;

  const [rows, setRows] = useState([]);

  const columns = [
    { field: "custID", headerName: "Customer Number", flex: 1,
    renderCell: (params) => (
      <div title={params.row.custID} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {params.value}
      </div>
    )
  },
    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1,
      renderCell: (params) => (
        <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {params.value}
        </div>
      )      
    },
    {
      field: "cgName",
      headerName: "Customer Group",
      flex: 1,
    },
    {
      field: "trustLevel",
      headerName: "Customer Trust Level",
      flex: 1,
      renderCell: (params) => {
        return <TrustLevel {...params} />;
      },
    },

    {
      field: "stickToQuota",
      headerName: "Automate STQ Decision",
      flex: 1,
      renderCell: (params) => {
        return <StickToQuota {...params} />;
      },
    },
  ];

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    setPartnerType("");
    setCustomerType("");
    dispatch(setState("clearCustomerTrustLevel", false));
  }, []);

  const TrustLevel = (params) => {
    const [trustLevel, setTrustLevel] = useState(params.row.trustLevel);

    const handleStatusChange = (e) => {
      setTrustLevel(e.target.value);
      apiRef.current.updateRows([
        { id: params.id, trustLevel: e.target.value },
      ]);
      setUpdatedValues((prev) => [...prev, params.row]);
    };
    return (
      <Select
        value={trustLevel}
        onChange={handleStatusChange}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>High</MenuItem>
        <MenuItem value={2}>Medium</MenuItem>
        <MenuItem value={3}>Low</MenuItem>
        <MenuItem value={4}>Others</MenuItem>
      </Select>
    );
  };

  const StickToQuota = (params) => {
    console.log(params.row.stickToQuota);
    const [status, setStatus] = useState(params.row.stickToQuota);
    const handleStatusChange = (e) => {
      setStatus(e.target.value);
      apiRef.current.updateRows([
        { id: params.id, stickToQuota: e.target.value },
      ]);
      setUpdatedValues((prev) => [...prev, params.row]);
      // Perform additional actions here, such as updating the row data
    };
    console.log(params);
    return (
      <Select
        value={status}
        onChange={handleStatusChange}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    );
  };

  useEffect(() => {
    if (customerTrustLevelData.length > 0) {
      setRows(customerTrustLevelData);
    }
    else {
      setRows([]);
    }
  }, [customerTrustLevelData]);
  console.log(rows);
  useEffect(() => {
    //Send data through the function in Slice
    dispatch(GetCustomerGroupReferenceData({ CountryID: selectedCountryID }));
  }, [selectedCountryID]);

  console.log(getCustomerGroupRefData);

  useEffect(() => {
    if (countries.length <= 0) {
      //Send data through the function in Slice
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [searchText]);

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const displaySuccess = () => {
    setAlert({
      alertSeverity: "success",
      alertDisplay: true,
      alertMessage: `Saved Successfully!`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  const handleDisplay = () => {
    if (selectedCountry === null || selectedCountry === "") {
      displayAlert("Country");
      return;
    }
    if (partnerType === null || partnerType === "") {
      displayAlert("Partner Type");
      return;
    }
    if (customerType === null || customerType === "") {
      displayAlert("Customer Type");
      return;
    }
    //  /ProductGroup/GetSKUSwitchSearch?CountryID=150&ProductName=ABACAV/LAMIVUD&SKUType=0
    //let partnerType1 = getCustomerGroupRefData?.customerLevels?.find(item => partnerType === item.customerLevel).customerLevelID;
    //let customerTypeCode1 = getCustomerGroupRefData?.customerTypes?.find(item => customerType === item.customerTypeName).customerTypeCode;
    let obj = {
      CountryID: selectedCountryID,
      CustomerName: searchText,
      CustomerCodeType: customerType,
      PartnerType: partnerType,
    };

    dispatch(setState("clearCustomerTrustLevel", true));
    dispatch(SearchCustomerTrustLevel(obj));
  };

  const handleCountryChange = (e) => {
    const name = e.target.value;
    console.log(countries.find((country) => country.countryName === name));
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleSave = () => {
    const finalArray = rowSelectionModel.map((id) => {
      let updatedTrustValues = apiRef.current.getRowWithUpdatedValues(id);
      return {
        id: updatedTrustValues.id,
        trustLevel: updatedTrustValues.trustLevel,
        stickToQuota: updatedTrustValues.stickToQuota,
      };
    });

    let obj = {
      CountryID: selectedCountryID,
      CustomerName: searchText,
      CustomerCodeType: customerType,
      PartnerType: partnerType,
    };

    console.log(finalArray);
    dispatch(UpdateCustomerTrustLevel(finalArray)).then(()=> {
      dispatch(SearchCustomerTrustLevel(obj));
    });

    displaySuccess();
  };

  return (
    <Box mt={2}>
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
      <Box mt={2}>
        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              //select={true}
              value={countries.length > 0 ? selectedCountry.countryName : ""}
              //value={""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
              //disabled={countries.length > 0 ? false : true}
              // {...register("country", {
              //     required: "Please select a country",
              // })}
              // error={Boolean(errors.country)}
              // helperText={errors ?.country ?.message}
            >
              {/* <MenuItem key={0} value={0}>
					   {"All"}
					   </MenuItem> */}
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>

          <Grid item xs={6} sm={3} md={2} lg={2}>
            <TextField
              variant="outlined"
              label="Partner Type"
              select={
                getCustomerGroupRefData?.customerLevels?.length > 0
                  ? true
                  : false
              }
              //value={countries.length > 0 ? selectedCountry.countryID : " "}
              value={partnerType}
              onChange={(e) => setPartnerType(e.target.value)}
              fullWidth
              size="small"
            >
              {getCustomerGroupRefData?.customerLevels?.map((item) => {
                return (
                  <MenuItem
                    key={item.customerLevelID}
                    value={item.customerLevelID}
                  >
                    {item.customerLevel}
                  </MenuItem>
                );
              })}
              {/* // 	 <MenuItem customerLevelID={"SH"} customerLevel={"Ship-to"}>
            //     {"Ship To"}
            //   </MenuItem>
            //   <MenuItem customerLevelID={"SP"} customerLevel={"Sold-to"}>
            //     {"Sold To"}
            //   </MenuItem> */}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Customer Type"
              select={
                getCustomerGroupRefData?.customerLevels?.length > 0
                  ? true
                  : false
              }
              //value={countries.length > 0 ? selectedCountry.countryID : " "}
              value={customerType}
              onChange={(e) => setCustomerType(e.target.value)}
              fullWidth
              size="small"
            >
              {getCustomerGroupRefData?.customerTypes?.map((item) => {
                return (
                  <MenuItem
                    key={item.customerTypeCode}
                    value={item.customerTypeCode}
                  >
                    {item.customerTypeName}
                  </MenuItem>
                );
              })}
              {/* // 	 <MenuItem customerLevelID={"SH"} customerLevel={"Ship-to"}>
            //     {"Ship To"}
            //   </MenuItem>
            //   <MenuItem customerLevelID={"SP"} customerLevel={"Sold-to"}>
            //     {"Sold To"}
            //   </MenuItem> */}
            </TextField>
          </Grid>

          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Search"
              //select={countries.length > 0 ? true : false}
              //value={countries.length > 0 ? selectedCountry.countryID : " "}
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>

          <Grid item xs={12} sm={3} md={1} lg={1}>
            <Box justifyContent="center" display="flex">
              <Button
                //startIcon={<SearchIcon />}
                variant="contained"
                onClick={handleDisplay}
                size="large"
                // className="mui_Button"
                //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
              >
                Search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {clearCustomerTrustLevel && (
        <Box
          mt={2}
          sx={{
            width: "100%",
            minHeight: "200px",
          }}
        >
          <DataGrid
            style={{ maxHeight: "calc(100vh - 130px)" }}
            apiRef={apiRef}
            rows={rows}
            columns={columns}
            getRowId={(row) => row?.id}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
      {rowSelectionModel.length > 0 ? (
        <Box mt={3} justifyContent="flex-end" display="flex">
          <Button
            //startIcon={<SearchIcon />}
            variant="contained"
            onClick={handleSave}
            size="large"
            disabled={!isRestrictedAccess}
            // className="mui_Button"
            //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
          >
            Save your changes
          </Button>
        </Box>
      ) : (
        <></>
      )}
      {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}
    </Box>
  );
}
